// extracted by mini-css-extract-plugin
export default {"row":"CourseHightlightComponent_row__CVEeX","title_box":"CourseHightlightComponent_title_box__c6T-0","img_box":"CourseHightlightComponent_img_box__ssSGZ"};